import React from 'react';
import { Modal } from 'antd';

import SelectWithFetchNext from '../../../shared/components/select-with-fetch-next';
import * as actions from '../store/actions';

const appendFileModal = ({ rootContainer, open, onClose, onAppendFormSelected }) => {
  const onSelect = (e) => {
    onClose();
    onAppendFormSelected(e);
  };

  return (
    <Modal
      className="append-file-modal"
      title="Append form"
      open={open}
      getContainer={rootContainer}
      centered
      onCancel={onClose}
      onOk={onClose}
      width={800}
    >
      <SelectWithFetchNext
        rootContainer={rootContainer}
        fetchNext={actions.getAcordLookup}
        placeholder="Select append form"
        onSelect={onSelect}
        className={'append-form-select'}
      />
    </Modal>
  );
};

export default appendFileModal;
